import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionTransactionEntity } from 'mj_generatedentities';
import { LogStatus, LogError } from '@memberjunction/core';
import { environment } from 'src/environments/environment';
import { loadStripe, StripeEmbeddedCheckout } from '@stripe/stripe-js';
import { SubscriptionPlanService } from 'src/app/core/services/subscription-plan.service';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/core/services/shared-service';

const MAX_RETRIES = 10;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrl: './checkout.component.css'
})
export class CheckoutComponent implements OnInit, OnDestroy {
  _transaction: SubscriptionTransactionEntity | null = null;

  isLoading = true;

  private checkout: StripeEmbeddedCheckout | null = null;
  
  constructor(
    private planService: SubscriptionPlanService,
    private sharedService: SharedService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {}

  async ngOnInit(): Promise<void> {
    let retries = 0;

    while (!this._transaction && retries < MAX_RETRIES) {
      this._transaction = this.planService.CurrentTransaction;
      this.cdr.detectChanges(); // Manually trigger change detection
      await new Promise(resolve => setTimeout(resolve, 500));
    }

    if (!this._transaction) {
      this.sharedService.NoAccessMessage = 'Failed to initialize transaction';
      this.sharedService.AccessDenied = true;
      return;
    }

    await this.initializeStripeWidget();
  }

  ngOnDestroy(): void {
    // Clean up Stripe Embedded Checkout instance
    if (this.checkout) {
      this.checkout.destroy();
      this.checkout = null;
    }
  }

  private async initializeStripeWidget() {
    try {
      console.log('Initializing Stripe Checkout');
      const stripe = await loadStripe(environment.STRIPE_PUBLISHABLE_KEY);
      const clientSecret = await this.planService.GetStripeTransactionClientSecret();
      if (!stripe) {
        throw new Error('Failed to initialize Stripe.');
      }
      
      this.checkout = await stripe.initEmbeddedCheckout({
        clientSecret,
      });
    
      if (this.checkout) {
        this.isLoading = false;
        
        this.cdr.detectChanges(); // Manually trigger change detection
        await new Promise(resolve => setTimeout(resolve, 500));
        // Mount Checkout
        this.checkout.mount('#checkout');
      } else {
        throw new Error('Failed to initialize Stripe Checkout.');
      }
    
    } catch (error) {
      LogError(error);
    }
  }

  public cancelAndGoBack(): void {
    // Remove the embedded checkout from the DOM
    if (this.checkout) {
      this.checkout.unmount();
      this.checkout = null;
    }

    this.router.navigate(['/onboarding/pricing']);
  }
}
